import React, { useEffect, useState } from "react";
import { InternalContent } from "@components/library";
import { useSelector } from "react-redux";
import { useTranslation } from "@helpers/translate";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from "react-router-dom";
import ProfileTab from "./components/ProfileTab";
import TradingProfileTab from "./components/TradingProfileTab";
import SettingsTab from "./components/SettingsTab";
import OndatoPopup from "./components/OndatoPopup";
import "./index.sass";

export const MyProfile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { __ } = useTranslation();
  const { theme } = useSelector((state) => state.theme);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
  const [inlinePopup, setInlinePopup] = useState(null);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 480);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const openInlinePopup = (name) => setInlinePopup(name);
  const closeInlinePopup = () => setInlinePopup(null);

  // Визначаємо активний таб з URL
  const getActiveTab = () => {
    const path = location.pathname;
    if (path === "/profile") {
      return "profile";
    } else if (path === "/profile/trading") {
      return "trading";
    } else if (path === "/profile/settings") {
      return "settings";
    }
    return "profile";
  };

  const activeTab = getActiveTab();

  const handleTabChange = (newTab) => {
    if (newTab === "profile") {
      navigate("/profile");
    } else {
      navigate(`/profile/${newTab}`);
    }
  };

  useEffect(() => {
    // Валідація табу з URL
    const validTabs = ["profile", "trading", "settings"];
    const currentTab = getActiveTab();
    if (!validTabs.includes(currentTab)) {
      navigate("/profile", { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <InternalContent
      bgImg={`../images/bg/bg-lamba2${theme === "white" ? "-white" : ""}.png`}
    >
      <Helmet>
        <title>
          {__("seo.my_profile")} {__("seo.divider")} {__("seo.title")}
        </title>
      </Helmet>
      {/* show modal popup only on non-mobile; on mobile we'll render inline version inside SettingsTab */}
      {!isMobile && <OndatoPopup />}

      <div className="profile-page">
        <div className="profile-page__tabs">
          <button
            className={`profile-page__tab ${
              activeTab === "trading" ? "active" : ""
            }`}
            onClick={() => handleTabChange("trading")}
          >
            {__("profile.trading_profile") || "Trading Profile"}
          </button>
          <button
            className={`profile-page__tab ${
              activeTab === "profile" ? "active" : ""
            }`}
            onClick={() => handleTabChange("profile")}
          >
            {__("common.profile") || "Profile"}
          </button>
          <button
            className={`profile-page__tab ${
              activeTab === "settings" ? "active" : ""
            }`}
            onClick={() => handleTabChange("settings")}
          >
            {__("common.security") || "Security"}
          </button>
        </div>

        <div className="profile-page__content">
          {activeTab === "profile" && <ProfileTab />}
          {activeTab === "trading" && <TradingProfileTab />}
          {activeTab === "settings" && (
            <SettingsTab
              isMobile={isMobile}
              inlinePopup={inlinePopup}
              openInlinePopup={openInlinePopup}
              closeInlinePopup={closeInlinePopup}
            />
          )}
        </div>
      </div>
    </InternalContent>
  );
};

export default MyProfile;
